import http from '@/utils/request'

export default function tryParse(content) {
  try {
    return JSON.parse(content)
  } catch(err) {
    http.post('/api/parse-error', { content })
  }

  return ''
}

export function parseStream(content) {
  const text = content.substring(0, content.lastIndexOf('}') + 1)

  return tryParse(`[${text.replace(/\}\{/g, '},{')}]`)
}
